<template>
  <div class="whs-layout">
    <transition name="fade">
      <img class="whs-main-image" :src="layoutBackground" :key="layoutBackground" />
    </transition>
    <!-- <div class="whs-main-description">
      <div class="whs-main-last whs-icon" @click="lastImage"></div>
      <div class="whs-main-next whs-icon" @click="nextImage"></div>
      <div class="whs-main-description-title">{{descriptionTitle}}</div>
      <div class="whs-main-description-content">{{descriptionContent}}</div>
    </div>-->
    <div class="whs-main-wrap">
      <div class="whs-main-title">Поиск и бронирование отелей онлайн</div>
      <Hero />
    </div>
  </div>
</template>

<script>
import Hero from '../components/Hero.vue';
import { GATEWAY } from '@/api';
import { mapGetters } from 'vuex';

export default {
  name: 'Main',
  components: {
    Hero
  },
  data: function() {
    return {
      description: [
        {
          title: 'Греция',
          content:
            'Здесь любой камень связан с древнегреческими богами, а каждый цветок в прошлом был возлюбленной одного из них'
        },
        {
          title: 'Турция',
          content:
            'Мост между Востоком и Западом. Страна, 90 процентов территории которой находится в Азии, имеет более 2000 лет европейской истории'
        },
        {
          title: 'ОАЭ',
          content:
            'Морской бриз играет дорогущими занавесями в окнах «семизвездочного» отеля, а со стоянки кочевников в дюнах видна светящаяся игла Бурдж-Халифа'
        }
      ],
      currentImage: Math.ceil(Math.random() * 3) - 1
    };
  },
  computed: {
    ...mapGetters(['context']),
    images() {
      return [
        `${GATEWAY}img/${
          ['pm', 'main-pm'].includes(this.context) ? 'pm/' : ''
        }greece.jpg`,
        `${GATEWAY}img/${
          ['pm', 'main-pm'].includes(this.context) ? 'pm/' : ''
        }turkey.jpg`,
        `${GATEWAY}img/${
          ['pm', 'main-pm'].includes(this.context) ? 'pm/' : ''
        }uae.jpg`
      ];
    },
    layoutBackground() {
      return this.images[this.currentImage];
    },
    descriptionTitle() {
      return this.description[this.currentImage].title;
    },
    descriptionContent() {
      return this.description[this.currentImage].content;
    }
  },
  methods: {
    nextImage() {
      this.currentImage =
        this.currentImage === this.images.length - 1
          ? 0
          : this.currentImage + 1;
    },
    lastImage() {
      this.currentImage =
        this.currentImage === 0
          ? this.images.length - 1
          : this.currentImage - 1;
    }
  }
};
</script>

<style scoped>
.whs-layout {
  min-height: 300px;
  /* background: url('../assets/gallery/greece.jpg') center center no-repeat; */
  /* background-size: cover; */
  background-color: var(--color-text);
  justify-content: flex-end;
  display: flex;
  position: relative;
}
.whs-main-image {
  position: absolute;
  z-index: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
  max-width: 100%;
}
.whs-main-title {
  padding: 108px 8px 16px;
  text-align: center;
  font-size: 32px;
  color: #fff;
  line-height: 1.4;
}
@media (max-width: 575px) {
  .whs-main-title {
    padding: 32px 8px 16px;
  }
}
.whs-main-wrap {
  background: linear-gradient(to top, #0004, #000a, #0000);
  z-index: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px 0 108px;
}
.whs-main-description {
  max-width: 300px;
  width: calc(100% - 72px);
  padding: 0 8px 0;
  background-color: var(--color-text-5);
  border-top: 8px solid var(--color-text-5);
  border-bottom: 8px solid var(--color-text-5);
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: flex-end;
  position: absolute;
  z-index: 2;
  top: 24px;
  right: 32px;
}
.whs-main-description-title {
  font-size: 18px;
}
.whs-main-description-content {
  height: 80px;
  font-size: 13px;
  overflow: hidden;
}
.whs-main-next,
.whs-main-last {
  position: absolute;
  left: -24px;
  visibility: default;
  cursor: pointer;
}
.whs-main-next {
  left: unset;
  right: -24px;
}
.whs-main-next:before,
.whs-main-last:before {
  content: '\f053';
  font-size: 28px;
  color: #fff;
}
.whs-main-next:before {
  content: '\f054';
}
</style>